import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_BLOG } from "../graphql/queries";
import { NavLink } from "react-router-dom";
import { ROUTES } from "../routes/routes";
export default function Blogdetail() {
    const { slug } = useParams();
    const { loading, error, data } = useQuery(GET_BLOG, {
        variables: { slug },
    });

    if (loading) return <p>Loading...</p>;
    if (error)
        return (
            <p>
                Error: {error.message} (Slug: {slug})
            </p>
        );

    if (!data || !data.blogs || data.blogs.length === 0) {
        return <p>No project found.</p>;
    }
    return data.blogs.map((blog) => (
        <div key={blog.id} className="main-container">
            <div className="go-back">
                <NavLink to={ROUTES.blog.path}> go back </NavLink>
            </div>
            <div className="detail-header">
                <div className="detail-content">
                    <h1 className="detail-titles">{blog.title}</h1>
                    <p className="detail-author"></p>
                </div>
                <img alt={blog.title} src={blog.image.url} />
            </div>
            <br />
            <p className="detail-description">{blog.description}</p>
            <p className="detail-date">{blog.date}</p>
            <br />
        </div>
    ));
}
